import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteInfo, siteStats } from '@/mocks/site';

const quickTags = ['私拍吃瓜名场面', '私拍吃瓜抓拍', '神操作', '尴尬瞬间', '高光瞬间'];

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    if (trimmed) {
      navigate(`/moments?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate('/moments');
    }
  };

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[660px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20neon%20lit%20entertainment%20studio%20stage%20with%20orange%20and%20rose%20spotlights%2C%20abstract%20haze%20and%20floating%20confetti%2C%20soft%20blurred%20bokeh%20lights%2C%20dark%20cinematic%20atmosphere%2C%20no%20people%2C%20editorial%20poster%20style&width=1600&height=900&seq=gt-hero-stage-main&orientation=landscape"
          alt="暖色灯光下的娱乐舞台氛围图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 pb-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm">
            <i className="ri-fire-line"></i>
            最新热门优先展示 · 每条约好三处关键画面
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-background-50">
            {siteInfo.name}
            <span className="block mt-3 text-primary-300">私拍吃瓜名场面,一屏看通透</span>
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100 max-w-2xl">
            把私拍吃瓜名场面、抓拍、神操作和尴尬瞬间、高光瞬间集中整理到同一条时间线上。
            想吃透人多瞬间不看？点标题就能快速定位关键画面,少吃瓜、少翻页。
          </p>

          <form onSubmit={handleSubmit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl">
            <div className="flex-1 flex items-center gap-2 px-4 py-3 rounded-md bg-background-50">
              <i className="ri-search-line text-lg text-foreground-400"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜名场面、抓拍、神操作、尴尬瞬间"
                aria-label="搜索名场面"
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 rounded-md text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始找画面
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-300">热门搜索</span>
            {quickTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => navigate(`/moments?q=${encodeURIComponent(tag)}`)}
                className="px-3 py-1.5 rounded-full text-xs bg-background-50/15 text-background-100 hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {siteStats.map((stat) => (
            <div key={stat.label} className="px-4 md:px-5 py-4 rounded-lg bg-background-50/10">
              <p className="font-heading text-2xl md:text-3xl text-primary-300">{stat.value}</p>
              <p className="mt-1 text-xs md:text-sm text-background-200">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}